import { OverlayRef } from "@angular/cdk/overlay";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { UiModalOptions } from "../modal.models";
import { BaseModalContainerComponent, NzModalRef } from "ng-zorro-antd/modal";
import { TransformModalOptions } from "@webapp/ui/modal/utils/modal.utils";

export class UiModalRef<T = NzSafeAny, R = NzSafeAny> extends NzModalRef<T, R> {
  constructor(modalOverlayRef: OverlayRef, modalConfig: UiModalOptions, public containerInstance: BaseModalContainerComponent) {
    super(modalOverlayRef, TransformModalOptions(modalConfig), containerInstance);
  }
}
